import { Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import successIcon from "assets/SuccessIcon.svg";
import c from "lib/style/colorVar.scss";
import { useTranslation } from "react-i18next";

/**
 *
 * @param {Object} props
 * @param {String} props.title
 * @param {String[]?} props.content
 * @param {Function} props.buttonAction
 * @param {String} props.buttonText
 * @param {Number?} props.countdown
 *
 * @returns
 */
const AuthResultLayout = ({
  title,
  content = [],
  buttonAction = () => {},
  buttonText,
  countdown,
}) => {
  const { t } = useTranslation();

  const [remainingSeconds, setRemainingSeconds] = useState(countdown);

  useEffect(() => {
    const redirectTime = Date.now() + countdown * 1000;
    const interval =
      countdown &&
      setInterval(() => {
        const remaining = Math.ceil((redirectTime - Date.now()) / 1000);
        setRemainingSeconds(remaining);
        if (remaining < 0) buttonAction();
      }, 1000);
    return () => countdown && clearInterval(interval);
  }, []);

  return (
    <Stack direction="column" alignItems="center">
      <img
        src={successIcon}
        alt={"success icon"}
        width={100}
        height={100}
        style={{ marginBottom: "24px" }}
      />
      <Typography variant="h2" sx={{ mb: 2 }}>
        {title}
      </Typography>
      <Stack
        direction="column"
        alignItems="center"
        gap={1}
        sx={{ mb: 3, textAlign: "center", width: { xs: "80%", md: "100%" } }}
      >
        {content.map((item, index) => (
          <Typography variant="content" key={index}>
            {item}
          </Typography>
        ))}
      </Stack>
      <Typography
        variant="button-normal"
        color={c["brandDark12"]}
        onClick={buttonAction}
        sx={{ cursor: "pointer", userSelect: "none" }}
      >
        {buttonText}
        {(remainingSeconds ?? null) !== null
          ? ` (${remainingSeconds < 0 ? 0 : remainingSeconds}${t("component.authResultLayout.second")})`
          : ""}
      </Typography>
    </Stack>
  );
};

export default AuthResultLayout;
